import PageHero from '../components/PageHero.jsx';
import KeyFacts from '../components/KeyFacts.jsx';
import ResourceList from '../components/ResourceList.jsx';
import { FadeUp } from '../components/Motion.jsx';
import { IconVial, IconSparkle, IconGlobe } from '../components/Icons.jsx';

const keyFacts = [
  { label: 'biolitec Pharma headquarters', value: 'Dublin, Ireland' },
  { label: 'Branch office', value: 'Jena, Germany' },
  { label: 'biolitec group headquarters', value: 'Vienna, Austria' },
  { label: 'Manufacturing & sales sites', value: 'Germany, Ireland, France, Malaysia and Latvia' },
  { label: 'Core competencies', value: 'Lasers, fibres and photosensitisers' },
];

const related = [
  { label: 'Foscan®', meta: 'Our photosensitiser', to: '/foscan', Icon: IconVial },
  { label: 'Photodynamic therapy', meta: 'The treatment platform', to: '/pdt', Icon: IconSparkle },
  { label: 'Contact us', meta: 'Offices and enquiries', to: '/contact', Icon: IconGlobe },
];

const competencies = [
  { title: 'Photosensitisers', desc: 'Foscan® and the wider PDT photosensitiser portfolio developed within the biolitec group.' },
  { title: 'Diode lasers', desc: 'CeramOptec-brand diode lasers developed and manufactured for a wide range of medical specialties.' },
  { title: 'Optical fibres', desc: 'Medical and industrial fibres and accessories engineered for light delivery.' },
];

export default function About() {
  return (
    <>
      <PageHero
        eyebrow="COMPANY • BIOLITEC GROUP"
        title="biolitec Pharma"
        subtitle="Production, marketing and clinical development of photodynamic therapy photosensitisers."
      />

      <div className="page-shell">
        <div className="page-grid">
          <div className="page-main">
            <FadeUp>
              <section className="page-section" id="who-we-are">
                <h2 className="page-section-title">Who we are</h2>
                <p className="page-body">
                  <strong>biolitec Pharma Ltd.</strong> is a company within the biolitec
                  group, responsible for the production and marketing of Foscan® for the
                  palliative treatment of advanced head and neck cancer. The company is
                  also responsible for developing further indications for Foscan® and the
                  clinical development of the photodynamic therapy (PDT) photosensitiser
                  portfolio within the biolitec group.
                </p>
                <p className="page-body">
                  biolitec Pharma Ltd. is headquartered in Dublin, Ireland, with a branch
                  office in Jena, Germany.
                </p>
              </section>
            </FadeUp>

            <FadeUp>
              <section className="page-section" id="competencies">
                <h2 className="page-section-title">Every core competency for PDT</h2>
                <p className="page-body">
                  The wider biolitec group is a leading developer and manufacturer of diode
                  lasers, optical fibres and accessories for a wide range of medical
                  specialties. The combination of CeramOptec-brand diode lasers and
                  medical and industrial fibres alongside biolitec Pharma’s Foscan® makes
                  the biolitec group unique in providing every core competency for
                  photodynamic therapy.
                </p>
                <div className="option-grid">
                  {competencies.map((c) => (
                    <div key={c.title} className="option-card">
                      <h3 className="option-card-title">{c.title}</h3>
                      <p className="option-card-desc">{c.desc}</p>
                    </div>
                  ))}
                </div>
              </section>
            </FadeUp>

            <FadeUp>
              <section className="page-section" id="group">
                <h2 className="page-section-title">The biolitec group</h2>
                <p className="page-body">
                  The biolitec group is headquartered in Vienna, Austria, with subsidiary
                  manufacturing and sales sites in Germany, Ireland, France, Malaysia and
                  Latvia, among others.
                </p>
                <p className="page-body">
                  The group’s goal is to support the development and sale of applications
                  that demonstrate improved clinical benefit and cost efficiency, providing
                  a complete laser, fibre, accessory and photosensitiser solution.
                </p>
              </section>
            </FadeUp>
          </div>

          <div className="page-aside">
            <KeyFacts title="At a glance" items={keyFacts} />
            <ResourceList title="Explore" items={related} />
          </div>
        </div>
      </div>
    </>
  );
}